import { ActionType, createAction } from 'typesafe-actions'

import { Dictionary } from '../../utils/types'
import { OrderData } from '../order/types'
import { DomainType, Domain } from '../domains'

import { ColumnSorting } from '../table/types'

import { OrderExportColumn } from './types'

export const OrdersActions = {
  loadOrders: createAction('ORDERS/load-orders')<{
    page: number
    pageSize: number
    sorting?: Dictionary<ColumnSorting>
  }>(),
  setOrders: createAction('ORDERS/set-orders')<{
    page: number
    totalPages: number
    data: OrderData[]
  }>(),
  setFilters: createAction('ORDERS/set-filters')<Dictionary<any>>(),
  clearFilter: createAction('ORDERS/clear-filters')<{ filterKey: string }>(),
  setSearchFilter: createAction('ORDERS/set-search-filter')<string>(),
  exportOrders: createAction('ORDERS/export-orders')<{
    columns: OrderExportColumn[]
    domains: Partial<Record<DomainType, Domain>>
    name: string
  }>(),
  downloadExport: createAction('ORDERS/download-export')<{ exportId: string }>()
}

export type OrdersActions = ActionType<typeof OrdersActions>
